import { useQuery, gql, useLazyQuery } from '@apollo/client';
import { DisciplinasQuery, DisciplinasQueryVariables } from './__generated__/DisciplinasQuery';

const DISCIPLINAS_QUERY = gql`
  query DisciplinasQuery($descricao: String, $pagina: Int, $itens_por_pagina: Int) {
    disciplinas(
      filter: { descricao: $descricao, pagina: $pagina, itens_por_pagina: $itens_por_pagina }
    ) {
      id_disciplina
      dsc_nome_disciplina
      dsc_sigla
      dsc_ementa
      num_carga_horaria
    }
  }
`;

const useDisciplinasQuery = (variables: DisciplinasQueryVariables) => {
  return useQuery<DisciplinasQuery, DisciplinasQueryVariables>(DISCIPLINAS_QUERY, {
    variables,
  });
};

const useDisciplinasLazyQuery = () => {
  return useLazyQuery<DisciplinasQuery, DisciplinasQueryVariables>(DISCIPLINAS_QUERY);
};

export { useDisciplinasQuery, useDisciplinasLazyQuery };
